import { Library, Users, GraduationCap } from "lucide-react"

interface SubjectStatsProps {
  totalSubjects: number
  activeTeachers: number
  totalEnrollment: number
}

export function SubjectStats({ totalSubjects, activeTeachers, totalEnrollment }: SubjectStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-blue-100 rounded-lg text-secondary">
          <Library className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Total Subjects</p>
          <h3 className="text-2xl font-bold text-foreground">{totalSubjects}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-teal-100 rounded-lg text-primary">
          <Users className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Active Teachers</p>
          <h3 className="text-2xl font-bold text-foreground">{activeTeachers}</h3>
        </div>
      </div>

      <div className="bg-card p-6 rounded-xl shadow-sm border border-border flex items-center gap-4">
        <div className="p-3 bg-purple-100 rounded-lg text-purple-600">
          <GraduationCap className="w-6 h-6" />
        </div>
        <div>
          <p className="text-sm text-muted-foreground font-medium">Total Enrollment</p>
          <h3 className="text-2xl font-bold text-foreground">{totalEnrollment}</h3>
        </div>
      </div>
    </div>
  )
}
